import { render } from "./studentsInfo.vue?vue&type=template&id=a7cf0e80&scoped=true"
import script from "./studentsInfo.vue?vue&type=script&lang=js"
export * from "./studentsInfo.vue?vue&type=script&lang=js"

import "./studentsInfo.vue?vue&type=style&index=0&id=a7cf0e80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7cf0e80"]])

export default __exports__